// ResizeObserver loop 에러 무시 (antd v5 알려진 이슈)
// 이 에러는 기능에 영향을 미치지 않으며, 브라우저와 antd의 리사이즈 감지 로직 간 타이밍 이슈로 발생
// 프로덕션에서만 적용하여 개발 환경에서는 디버깅 가능하도록 유지
if (typeof window !== 'undefined' && import.meta.env.PROD) {
  const resizeObserverErr = (e: ErrorEvent) => {
    if (e.message?.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
    }
  };
  window.addEventListener('error', resizeObserverErr);

  // console.error도 패치하여 ResizeObserver 관련 에러 숨김
  const originalConsoleError = console.error;
  console.error = (...args: unknown[]) => {
    const message = args[0];
    if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}

import React from 'react';
import { createRoot } from 'react-dom/client';
// dayjs 플러그인(특히 customParseFormat)을 전역 등록하기 위한 side-effect import.
// 이 import가 빠지면 `dayjs(str, format, true)` strict 파싱이 무력화돼 Safari/WebView에서 Invalid Date가 될 수 있다.
import './lib/dayjs';
import Root from './root';
import 'react-table/react-table.css';
import 'cropperjs/dist/cropper.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-image-crop/dist/ReactCrop.css';
import './styles/lib/custom_antd.scss';
import './styles/lib/ant-legacy-form.scss';
import './styles/main.scss';

async function enableMocking() {
  if (import.meta.env.VITE_API_MOCKING !== 'enabled') {
    return;
  }
  const { worker } = await import('./mocks/browser');
  return worker.start({ onUnhandledRequest: 'bypass' });
}

enableMocking().then(async () => {
  const container = document.getElementById('root');
  if (!container) throw new Error('Root container not found');
  const root = createRoot(container);

  let DevTools: (() => React.JSX.Element | null) | null = null;
  if (import.meta.env.VITE_API_MOCKING === 'enabled') {
    const mod = await import('@amondz/msw/devtools');
    DevTools = mod.MswDevTools;
  }

  root.render(
    <>
      <Root />
      {DevTools && <DevTools />}
    </>,
  );
});
